import angular from 'angular';

import component from './messageList.component';

let module = angular.module('recaps.components.messageList', [
]);

module.component('messageList', component);

export default module;
